<div 
  appAutoScroll 
  [scrollRate]="scrollSpeed" 
  [startDelay]="2000" 
  [pauseTime]="4000"
  *ngIf="autoScrollEnabled">
<!-- Header -->
<header class="header" [class.scrolled]="headerScrolled">
  <div class="header-container">
    <div class="logo" (click)="scrollToSection('hero')">
      <img src="assets/Brokins_logo_RGB22.png" alt="Brokins" />
    </div>
    
    <nav class="desktop-nav">
      <a [routerLink]="['/landing']">Accueil</a>
      
      <!-- Dropdown Nos assurances -->
      <div class="nav-dropdown">
        <a class="dropdown-toggle">
          Nos assurances <i class="pi pi-chevron-down"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-categories">
          <!-- Category 1: Assurance des Personnes pour Particuliers -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Personnes pour Particuliers
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-sante-particuliers']">Assurance Mutuelle Santé Individuelle</a>
              <a [routerLink]="['/assurance-mutuelle-sante-internationale']">Assurance Mutuelle Santé Internationale</a>
              <a [routerLink]="['/assurance-prevoyance-gav']">Assurance Prévoyance GAV</a>
              <a [routerLink]="['/assurance-prevoyance-ijh']">Assurance Prévoyance IJH</a>
              <a [routerLink]="['/assurance-prevoyance-obseque']">Assurance Prévoyance Obsèque</a>
              <a [routerLink]="['/assurance-prevoyance-deces']">Assurance Prévoyance Décès</a>
              <a [routerLink]="['/assurance-retraite-complementaire-salarie']">Assurance Retraite Complémentaire Salarié</a>
              <a [routerLink]="['/assurance-voyage-personnel']">Assurance Voyage Personnel</a>
              <a [routerLink]="['/assurance-credit-emprunteur']">Assurance Crédit — Assurance Emprunteur</a>
            </div>
          </div>

          <!-- Category 2: Assurance des Personnes pour Professionnels et Entreprises -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Personnes pour Professionnels et Entreprises
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-sante-professionnels']">Assurance Mutuelle Santé Professionnelle</a>
              <a [routerLink]="['/assurance-mutuelle-sante-internationale-pro']">Assurance Mutuelle Santé Internationale Professionnelle</a>
              <a [routerLink]="['/assurance-collective-entreprise']">Assurance Mutuelle Santé Entreprise</a>
              <a [routerLink]="['/assurance-prevoyance-professionnelle']">Assurance Prévoyance Professionnelle</a>
              <a [routerLink]="['/assurance-prevoyance-entreprise']">Assurance Prévoyance Entreprise</a>
              <a [routerLink]="['/assurance-retraite-complementaire-pro']">Assurance Retraite Complémentaire Professionnelle</a>
              <a [routerLink]="['/assurance-retraite-complementaire-entreprise']">Assurance Retraite Complémentaire Entreprise</a>
              <a [routerLink]="['/assurance-voyage-professionnel']">Assurance Voyage Professionnel</a>
            </div>
          </div>

          <!-- Category 3: Assurance des Biens pour Particuliers -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Biens pour Particuliers
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-multirisque-habitation']">Assurance Multirisque Habitation</a>
              <a [routerLink]="['/assurance-auto-particuliers']">Assurance Auto Personnelle</a>
              <a [routerLink]="['/assurance-moto-personnelle']">Assurance Moto Personnelle</a>
              <a [routerLink]="['/assurance-auto-temporaire']">Assurance Auto Temporaire</a>
              <a [routerLink]="['/assurance-multirisque-immeuble-pno']">Assurance Multirisque Immeuble - MAI - PNO</a>
              <a [routerLink]="['/assurance-loyers-impayes']">Assurance Loyers Impayés</a>
              <a [routerLink]="['/assurance-protection-juridique']">Assurance Protection Juridique</a>
              <a [routerLink]="['/assurance-oeuvres-art-bijoux']">Assurance Œuvres d'Art — Bijoux</a>
              <a [routerLink]="['/assurance-dommages-ouvrage']">Assurance Dommages Ouvrage</a>
              <a [routerLink]="['/assurance-animaux']">Assurance Chiens — Chats — Animaux</a>
              <a [routerLink]="['/assurance-velo-trottinette']">Assurance Vélo — Trottinette Electrique</a>
            </div>
          </div>

          <!-- Category 4: Assurance des Biens pour Professionnels et Entreprises -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Biens pour Professionnels et Entreprises
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-auto-professionnelle']">Assurance Auto Professionnelle</a>
              <a [routerLink]="['/assurance-moto-professionnelle']">Assurance Moto Professionnelle</a>
              <a [routerLink]="['/assurance-flotte-automobile']">Assurance Flotte Auto Professionnelle</a>
              <a [routerLink]="['/assurance-flotte-moto-professionnelle']">Assurance Flotte Moto Professionnelle</a>
              <a [routerLink]="['/assurance-multirisque-pro']">Assurance Multirisque Professionnelle</a>
              <a [routerLink]="['/assurance-multirisque-immeuble-pro']">Assurance Multirisque Immeuble — MAI — PNE</a>
              <a [routerLink]="['/assurance-bris-machine']">Assurance Bris de Machine</a>
              <a [routerLink]="['/assurance-cyber-risque']">Assurance Risque Cybersécurité Informatique — Cyberattaque</a>
              <a [routerLink]="['/assurance-locaux-professionnels']">Assurance Loueur de Véhicules</a>
              <a [routerLink]="['/assurance-marchandises-transportees']">Assurance Marchandises Transportées</a>
              <a [routerLink]="['/assurance-transport']">Assurance Transport</a>
            </div>
          </div>

          <!-- Category 5: Assurance de l'Activité des Professionnels et Entreprises -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance de l'Activité des Professionnels et Entreprises
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-rc-entreprise']">Assurance Responsabilité Civile</a>
              <a [routerLink]="['/assurance-rc-mandataires-sociaux']">Assurance Responsabilité Civile Mandataires Sociaux</a>
              <a [routerLink]="['/assurance-rc-decennale']">Assurance Responsabilité Civile Décennale</a>
              <a [routerLink]="['/assurance-protection-juridique-pro']">Assurance Protection Juridique Professionnelle</a>
              <a [routerLink]="['/assurance-perte-exploitation']">Assurance Perte d'Exploitation</a>
              <a [routerLink]="['/assurance-homme-cle']">Assurance Homme-Clé</a>
              <a [routerLink]="['/assurance-credit-professionnel']">Assurance Crédit Professionnel</a>
            </div>
          </div>

          <!-- Category 6: Autres Assurances -->
          <div class="dropdown-category">
            <div class="category-header highlight">
              Autres Assurances
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/autres-assurances']" class="highlight-link">
                Voir toutes les assurances (45+)
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Dropdown Pourquoi Brokins -->
      <div class="nav-dropdown">
        <a class="dropdown-toggle">
          Pourquoi Brokins <i class="pi pi-chevron-down"></i>
        </a>
        <div class="dropdown-menu">
          <a [routerLink]="['/qui-sommes-nous']">Qui Sommes-Nous</a>
          <a [routerLink]="['/notre-equipe']">Notre Équipe</a>
          <a [routerLink]="['/notre-approche']">Notre Approche</a>
          <a [routerLink]="['/avantages-courtier-brokins']">Avantages courtier Brokins</a>
        </div>
      </div>
      
      <a [routerLink]="['/blog']">Blog</a>
      <a [routerLink]="['/recrutement']">Recrutement</a>
      <a [routerLink]="['/contact']">Contact</a>
    </nav>

    <div class="header-actions">
      <button class="btn-devis" (click)="navigateToComparison()">Devis</button>
      <button class="hamburger" (click)="toggleMobileMenu()">
        <i class="pi pi-bars"></i>
      </button>
    </div>
  </div>

  <!-- Mobile Menu -->
  <div class="mobile-menu" [class.open]="mobileMenuOpen">
    <button class="close-btn" (click)="toggleMobileMenu()">
      <i class="pi pi-times"></i>
    </button>
    <nav>
      <a [routerLink]="['/landing']" (click)="toggleMobileMenu()">Accueil</a>
      
      <!-- Mobile Dropdown Nos assurances -->
      <div class="mobile-dropdown">
        <a class="mobile-dropdown-toggle" (click)="toggleMobileDropdown('assurances')">
          Nos assurances <i class="pi" [ngClass]="mobileDropdowns['assurances'] ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </a>
        <div class="mobile-dropdown-content" *ngIf="mobileDropdowns['assurances']">
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Activité - Pro/Entreprises</span>
            <a [routerLink]="['/assurance-perte-exploitation']" (click)="toggleMobileMenu()">Perte d'Exploitation</a>
            <a [routerLink]="['/assurance-homme-cle']" (click)="toggleMobileMenu()">Homme-Clé</a>
            <a [routerLink]="['/assurance-credit-professionnel']" (click)="toggleMobileMenu()">Crédit Pro</a>
          </div>
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Autres Assurances</span>
            <a [routerLink]="['/autres-assurances']" (click)="toggleMobileMenu()">Voir toutes nos assurances</a>
          </div>
        </div>
      </div>
      
      <!-- Mobile Dropdown Pourquoi Brokins -->
      <div class="mobile-dropdown">
        <a class="mobile-dropdown-toggle" (click)="toggleMobileDropdown('brokins')">
          Pourquoi Brokins <i class="pi" [ngClass]="mobileDropdowns['brokins'] ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </a>
        <div class="mobile-dropdown-content" *ngIf="mobileDropdowns['brokins']">
          <a [routerLink]="['/qui-sommes-nous']" (click)="toggleMobileMenu()">Qui Sommes-Nous</a>
          <a [routerLink]="['/notre-equipe']" (click)="toggleMobileMenu()">Notre Équipe</a>
          <a [routerLink]="['/notre-approche']" (click)="toggleMobileMenu()">Notre Approche</a>
          <a [routerLink]="['/avantages-courtier-brokins']" (click)="toggleMobileMenu()">Avantages courtier Brokins</a>
        </div>
      </div>
      
      <a [routerLink]="['/blog']" (click)="toggleMobileMenu()">Blog</a>
      <a [routerLink]="['/recrutement']" (click)="toggleMobileMenu()">Recrutement</a>
      <a [routerLink]="['/contact']" (click)="toggleMobileMenu()">Contact</a>
      <button class="btn-devis-mobile" (click)="navigateToComparison()">Obtenir un devis</button>
    </nav>
  </div>
</header>

<!-- Page Hero with Video -->
<section class="page-hero" *ngIf="heroVideo" >
  <video class="hero-video" autoplay muted loop playsinline>
    <source [src]="heroVideo" type="video/mp4">
  </video>
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <div class="hero-title-wrapper">
      <div class="hero-line"></div>
      <h1>{{ title }}</h1>
    </div>
    <p class="hero-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    <div class="hero-actions" *ngIf="phoneNumber || additionalPhoneNumber || heroCtaLink">
      <div class="hero-phone-row" *ngIf="phoneNumber || additionalPhoneNumber">
        <a *ngIf="additionalPhoneNumber" [href]="getPhoneLink(additionalPhoneNumber)" class="hero-phone">
          <i class="pi pi-phone"></i> {{ additionalPhoneNumber }}
        </a>
        <a *ngIf="phoneNumber" [href]="getPhoneLink(phoneNumber)" class="hero-phone">
          <i class="pi pi-phone"></i> {{ phoneNumber }}
        </a>
      </div>
      <a *ngIf="heroCtaLink" [routerLink]="heroCtaLink" class="hero-devis-button">
        {{ heroCtaLabel || 'Obtenir un devis gratuit' }}
      </a>
    </div>
  </div>
</section>

<!-- Page Hero with Image -->
<section class="page-hero" *ngIf="!heroVideo" [style.background-image]="'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(' + heroImage + ')'">
  <div class="hero-content">
    <div class="hero-title-wrapper">
      <div class="hero-line"></div>
      <h1>{{ title }}</h1>
    </div>
    <p class="hero-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    <div class="hero-actions" *ngIf="phoneNumber || additionalPhoneNumber || heroCtaLink">
      <div class="hero-phone-row" *ngIf="phoneNumber || additionalPhoneNumber">
        <a *ngIf="additionalPhoneNumber" [href]="getPhoneLink(additionalPhoneNumber)" class="hero-phone">
          <i class="pi pi-phone"></i> {{ additionalPhoneNumber }}
        </a>
        <a *ngIf="phoneNumber" [href]="getPhoneLink(phoneNumber)" class="hero-phone">
          <i class="pi pi-phone"></i> {{ phoneNumber }}
        </a>
      </div>
      <a *ngIf="heroCtaLink" [routerLink]="heroCtaLink" class="hero-devis-button">
        {{ heroCtaLabel || 'Obtenir un devis gratuit' }}
      </a>
    </div>
  </div>
</section>

<!-- Breadcrumb -->
<div class="breadcrumb" *ngIf="breadcrumbs && breadcrumbs.length > 0">
  <div class="container">
    <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
      <a *ngIf="crumb.link" [routerLink]="crumb.link">{{ crumb.label }}</a>
      <span *ngIf="!crumb.link" class="current">{{ crumb.label }}</span>
      <span *ngIf="!last" class="separator">/</span>
    </ng-container>
  </div>
</div>

<!-- Page Content - This is where child content is projected -->
<section class="page-content">
  <div class="container">
    <ng-content></ng-content>
  </div>
</section>

<!-- Partners Section -->
<section class="partners-section" *ngIf="showPartners && partners.length > 0">
  <div class="container">
    <h2>Nos Partenaires</h2>
    <p class="section-intro">Ils nous font confiance</p>
    
    <!-- Carousel infini -->
    <div class="slider">
      <div class="slide-track">
        <!-- Première série de logos -->
        <div class="slide" *ngFor="let partner of partners">
          <img 
            [src]="partner.logo" 
            [alt]="partner.name"
            class="partner-logo">
        </div>
        <!-- Duplication pour l'effet infini -->
        <div class="slide" *ngFor="let partner of partners">
          <img 
            [src]="partner.logo" 
            [alt]="partner.name"
            class="partner-logo">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Page Navigation -->
<div class="page-navigation" *ngIf="prevPage || nextPage">
  <div class="container">
    <div class="nav-grid">
      <a *ngIf="prevPage" [routerLink]="prevPage.link" class="nav-link prev">
        <div class="nav-circle">
          <i class="pi pi-arrow-left"></i>
        </div>
        <div class="nav-title">{{ prevPage.title }}</div>
      </a>
      <div *ngIf="!prevPage" class="nav-placeholder"></div>
      
      <a *ngIf="nextPage" [routerLink]="nextPage.link" class="nav-link next">
        <div class="nav-title">{{ nextPage.title }}</div>
        <div class="nav-circle">
          <i class="pi pi-arrow-right"></i>
        </div>
      </a>
      <div *ngIf="!nextPage" class="nav-placeholder"></div>
    </div>
  </div>
</div>



<!-- CTA Section -->
<section class="cta-section">
  <div class="container">
    <h2>Besoin d'un devis personnalisé ?</h2>
    <p>Nos conseillers sont à votre disposition pour vous accompagner</p>
    <div class="cta-buttons">
      <button class="btn-primary-large" (click)="navigateToComparison()">Obtenir un devis gratuit</button>
      <button class="btn-secondary-large" [routerLink]="['/contact']">Nous contacter</button>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-column">
        <img src="assets/logo.png" alt="Brokins" class="footer-logo">
        <p class="footer-tagline">Votre courtier en assurances de confiance depuis 2016</p>
        <div class="social-icons">
          <a href="#" aria-label="LinkedIn"><i class="pi pi-linkedin"></i></a>
          <a href="#" aria-label="Facebook"><i class="pi pi-facebook"></i></a>
          <a href="#" aria-label="Twitter"><i class="pi pi-twitter"></i></a>
          <a href="#" aria-label="Instagram"><i class="pi pi-instagram"></i></a>
        </div>
      </div>

      <div class="footer-column">
        <h4>Navigation</h4>
        <ul>
          <li><a [routerLink]="['/landing']">Accueil</a></li>
          <li><a [routerLink]="['/autres-assurances']">Nos assurances</a></li>
          <li><a [routerLink]="['/qui-sommes-nous']">Qui sommes-nous</a></li>
          <li><a [routerLink]="['/contact']">Contact</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Mentions Légales</h4>
        <ul>
          <li><a [routerLink]="['/mentions-legales']">Mentions légales</a></li>
          <li><a [routerLink]="['/cgv']">Conditions de vente</a></li>
          <li><a [routerLink]="['/politique-confidentialite']">Politique de confidentialité</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Contact</h4>
        <ul class="contact-list">
          <li><i class="pi pi-phone"></i><a href="tel:0143271243">01 43 27 12 43</a></li>
          <li><i class="pi pi-envelope"></i><a href="mailto:contact@brokins.fr">contact&#64;brokins.fr</a></li>
          <li><i class="pi pi-map-marker"></i>79 rue de Rennes, 75006 Paris</li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; 2025 Brokins SAS – Tous droits réservés</p>
      <button class="scroll-to-top" (click)="scrollToTop()">
        <i class="pi pi-arrow-up"></i>
      </button>
    </div>
  </div>
</footer>
</div>
